import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Typography, useViewport } from '@chilecompra/react-kit'
import { useAccessibility } from '../../../modules/utils/accesibility'
import {
  DialogButtonContainer,
  DialogContainer,
  DialogSubContainer,
  Image,
  Link,
  DownloadItemArea,
  DownloadIcon,
  LoadingIcon
} from './SuccessModal.styles'

/**
 * Success's modal component.
 */
const SuccessModal = ({
  open,
  onClose,
  confirmAction,
  loadingConfirmation,
  loadingAgreement,
  downloadAgreementAction
}) => {
  const { size, isDownToMedium } = useViewport()
  const modalRef = useRef(null)

  useAccessibility(open, size, modalRef)

  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        maxWidth="420px"
        margin={size.isTiny ? '84px 18px auto 18px' : '0 auto'}
        padding="16px"
        verticalAlign="center"
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
        ref={modalRef}
      >
        <DialogContainer>
          <Image src="/assets/images/circle_icon.svg" alt="Convenio de adhesión firmado con éxito" />
          <DialogSubContainer>
            <Typography tabIndex="0" id="success-modal-title" fontWeight="bold" variant="h4" textAlign="center">
              Convenio de adhesión firmado con éxito
            </Typography>
          </DialogSubContainer>
          <DialogButtonContainer>
            <Button
              tabIndex="0"
              aria-label="Continuar"
              loading={loadingConfirmation}
              color="success"
              size="medium"
              onClick={confirmAction}
            >
              Continuar
            </Button>
          </DialogButtonContainer>

          <DialogButtonContainer margin="35px 0 0 0">
            <DownloadItemArea xs={12} md={3} padding={isDownToMedium ? '0 0 20px' : '0'}>
              {loadingAgreement ? <LoadingIcon /> : <DownloadIcon onClick={downloadAgreementAction} />}

              <Link
                onClick={downloadAgreementAction}
                underline
                textAlign="right"
                color="primary"
                weight="500"
                size="15px"
                disabled={loadingAgreement}
              >
                Descargar Convenio de Adhesión Firmado
              </Link>
            </DownloadItemArea>
          </DialogButtonContainer>
        </DialogContainer>
      </Dialog>
    </>
  )
}

SuccessModal.defaultProps = {
  downloadAgreementAction: () => undefined,
  confirmAction: () => undefined,
  onClose: () => undefined,
  loadingConfirmation: false,
  loadingAgreement: false,
  open: false
}

SuccessModal.propTypes = {
  downloadAgreementAction: PropTypes.func,
  confirmAction: PropTypes.func,
  onClose: PropTypes.func,
  loadingConfirmation: PropTypes.bool,
  loadingAgreement: PropTypes.bool,
  open: PropTypes.bool
}

export default SuccessModal
